import {
    AuthTop,
    AuthLeft,
    AuthMain,
    AuthBottom,
    AuthNavLogo,
    AuthContainer,
    AuthFormsContainer,
    AuthMainCatchPhrase,
    GreenitNavContainer,
    GreenitNavLogoContainer,
    AuthNavLogoArabic,
} from '../AuthElements';
import TutorialCards from '../components/TutorialCards';
import { ForgotPasswordForm } from './ForgotPasswordForm';
import { BaseButton, ResponsiveText } from '@custom_components';


// IMPORT STYLES
import { COLORS } from '@project/styles';

// IMPORT HELPERS
import { RouterPages } from '@project/routes';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import i18next from 'i18next';
import { Helmet } from 'react-helmet';



const ForgotPassword = () => {
    const direction = i18next.dir();
    const [params, _] = useSearchParams();

    const { t } = useTranslation();
    const nextPath = params.get('next');

    return (
        <AuthContainer>
            <Helmet>
                <title>{t('auth.forgotPasswordMetaTitle')}</title>
                <meta name="robots" content="noindex" />
            </Helmet>
            <AuthLeft {...{ color: COLORS.AUTH.FORGOT_PASSWORD.SECONDARY }}>
                <AuthTop>
                    <AuthMainCatchPhrase {...{ color: COLORS.AUTH.FORGOT_PASSWORD.TERTIARY }}>
                        {t("auth.tutorialCatchphrase")}
                    </AuthMainCatchPhrase>
                </AuthTop>
                <AuthBottom>
                    <TutorialCards {...{ colors: COLORS.AUTH.FORGOT_PASSWORD }} />
                </AuthBottom>
            </AuthLeft>
            <AuthMain>
                <GreenitNavContainer {...{
                    page: RouterPages.Login,
                    pageSearchParams: nextPath ? { next: nextPath } : undefined
                }}>
                    <BaseButton {...{
                        style: {
                            marginTop: '2%',
                            cursor: 'pointer',
                        }, onClick: () => { },
                    }}>
                        <ResponsiveText props={{ marginTop: '5%', marginBottom: '35%' }}>
                            {t('auth.goBackTo')}{' '}
                            <span style={{ fontWeight: 'bold', color: COLORS.AUTH.FORGOT_PASSWORD.PRIMARY }}>
                                {t('auth.logIn')}
                            </span>
                        </ResponsiveText>
                    </BaseButton>
                </GreenitNavContainer>
                <GreenitNavLogoContainer>
                    {
                        direction === 'ltr' ? < AuthNavLogo  {...{ page: RouterPages.Home }} />
                            : <AuthNavLogoArabic  {...{ page: RouterPages.Home }} />
                    }
                </GreenitNavLogoContainer>
                <AuthFormsContainer>
                    <ForgotPasswordForm {...{ nextPath }} />
                </AuthFormsContainer>
            </AuthMain>
        </AuthContainer>
    );
};

export default ForgotPassword;
